import React from "react";

interface IPropsDashboardLayoutGridAndRows {
    children?: React.ReactNode;
    display?: 'grid' | 'row'
}

export const DashboardLayoutGridAndRows: React.FC<IPropsDashboardLayoutGridAndRows> = ({children, display = 'line'}) => {
    return (
        <ul className={`dashboard-list-layout__${display}`}>
            {children}
        </ul>
    )
}